/**
 * Uses to push modules into the plugins.js up-front dependency list
 * Consider lazy-loading optional modules (e.g. analytics)
 */
define('componentLoader', ['componentHelper'], function(helper) {

  /*
  *
  *
  *
  *
  *
  *
  * !!!!!! STOP !!!!!!
  *
  * Do not add ANYTHING ELSE INTO THIS FILE!
  * Simply add this to your component and your component will load via this file:
  *
  * data-component="componentName"
  *
  *
  * See this link for documentation: https://thehut.atlassian.net/wiki/display/FED/Using+the+Component+Loader
  *
  *
  *
  *
  *
  *
   */

  /* New component loader with temporary shim to continue using component helper */
  var createComponentInstance = function(componentElement) {
    var componentName = componentElement.getAttribute('data-component');
    // only the else branch should remain after all components have been refactored.
    if (componentElement.hasAttribute('data-componentLoad') && componentElement.getAttribute('data-componentLoad') === 'helper') {
      helper.promote([componentName]);
    } else {
      if (helper.isModule(componentName)) {
        require([componentName], function(componentScript) {
          componentElement.componentObject = new componentScript().init(componentElement);
        });
      }
    }
  };
  // here is the query and loop
  var componentElements = document.querySelectorAll('[data-component]');
  if (componentElements.length) {
    for (var i = 0; i < componentElements.length; i++) {
      createComponentInstance(componentElements[i]);
    }
  }

  /**
   * Return ComponentHelper instance
   */
  return helper;
});
